(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nf-application-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const controllerKey = '__nfApplicationGuideController';
  if (window[controllerKey]) {
    window[controllerKey].init(document);
    return;
  }
  const instances = new Map();
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initGuide(root) {
    if (instances.has(root)) return;
    const abort = new AbortController();
    const options = { signal: abort.signal };
    const search = root.querySelector('[data-application-search]');
    const clear = root.querySelector('[data-clear-search]');
    const status = root.querySelector('[data-search-status]');
    const empty = root.querySelector('[data-search-empty]');
    const sections = [...root.querySelectorAll('[data-category]')].map(section => ({
      section,
      count: section.querySelector('[data-section-count]'),
      rows: [...section.querySelectorAll('tbody tr')].map(row => ({
        row, name: row.querySelector('th').textContent.toLocaleLowerCase()
      }))
    }));
    let savedOpenState = null;
    let printState = null;
    function filter() {
      const query = search.value.trim().toLocaleLowerCase();
      if (query && !savedOpenState) savedOpenState = sections.map(({ section }) => section.open);
      let matches = 0;
      let categories = 0;
      sections.forEach(({ section, rows, count }, index) => {
        let categoryMatches = 0;
        rows.forEach(({ row, name }) => {
          row.hidden = Boolean(query) && !name.includes(query);
          if (!row.hidden) categoryMatches++;
        });
        section.hidden = Boolean(query) && categoryMatches === 0;
        if (query && categoryMatches) section.open = true;
        if (!query && savedOpenState) section.open = savedOpenState[index];
        count.textContent = query ? `${categoryMatches} of ${rows.length} applications` : `${rows.length} applications`;
        matches += categoryMatches;
        if (categoryMatches) categories++;
      });
      clear.hidden = !query;
      status.hidden = !query;
      empty.hidden = !query || matches > 0;
      status.textContent = query ? `${matches} matching ${matches === 1 ? 'application' : 'applications'} in ${categories} ${categories === 1 ? 'category' : 'categories'}.` : '';
      if (!query) savedOpenState = null;
    }
    function clearSearch() {
      search.value = '';
      filter();
    }
    search.addEventListener('input', filter, options);
    search.addEventListener('keydown', event => {
      if (event.key === 'Escape') { clearSearch(); search.focus(); }
    }, options);
    clear.addEventListener('click', () => { clearSearch(); search.focus(); }, options);
    root.addEventListener('click', event => {
      const button = event.target.closest('button[data-scroll-target]');
      if (!button || !root.contains(button)) return;
      const target = document.getElementById(button.dataset.scrollTarget);
      if (!target || !root.contains(target)) return;
      if (search.value.trim()) clearSearch();
      if (target.tagName === 'DETAILS') target.open = true;
      target.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
      const focusTarget = target.tagName === 'DETAILS' ? target.querySelector('summary') : target;
      focusTarget.focus({ preventScroll: true });
    }, options);
    window.addEventListener('beforeprint', () => {
      printState = sections.map(({ section, rows }) => ({
        open: section.open, hidden: section.hidden, rows: rows.map(({ row }) => row.hidden)
      }));
      sections.forEach(({ section, rows }) => {
        section.open = true;
        section.hidden = false;
        rows.forEach(({ row }) => { row.hidden = false; });
      });
    }, options);
    window.addEventListener('afterprint', () => {
      if (!printState) return;
      sections.forEach(({ section, rows }, index) => {
        section.open = printState[index].open;
        section.hidden = printState[index].hidden;
        rows.forEach(({ row }, rowIndex) => { row.hidden = printState[index].rows[rowIndex]; });
      });
      printState = null;
    }, options);
    instances.set(root, { abort });
    root.querySelector('[data-search-ui]').hidden = false;
    filter();
  }
  function init(scope) {
    if (scope.matches?.('[data-nf-guide]')) initGuide(scope);
    scope.querySelectorAll('[data-nf-guide]').forEach(initGuide);
  }
  function unload(scope) {
    for (const [root, instance] of instances) {
      if (root === scope || scope.contains(root)) {
        instance.abort.abort();
        instances.delete(root);
      }
    }
  }
  window[controllerKey] = { init };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => unload(event.target));
  document.addEventListener('shopify:block:select', event => {
    const category = event.target.closest('[data-category]');
    const root = category?.closest('[data-nf-guide]');
    if (!category || !root) return;
    const search = root.querySelector('[data-application-search]');
    search.value = '';
    search.dispatchEvent(new Event('input', { bubbles: true }));
    category.open = true;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();

  } catch(e) { console.error(e); }
})();
})();
